<template>
<div class="main-body">
  <b-alert
    dismissible
    :show="showDismissibleAlert"
    :variant="alertVariant"
    @dismissed="showDismissibleAlert=false">{{ alertMessage }}</b-alert>
    <form>
      <div class="card">
          <div class="card-body">
              <div class="row">
                  <div class="col-sm-5">
                      <h4 class="card-title mb-0">
                        {{ $t('delivery.label.pending_order') }} <small class="text-muted"> {{ $t('general.create') }}</small>
                      </h4>
                  </div><!--col-->
              </div><!--row-->

              <div class="row mt-4">
                  <div class="col">
                      <div class="form-group row">
                        <label for="service_code" class="col-sm-2 col-form-label">{{ $t('delivery.label.service_name') }}</label>
                        <div class="col-sm-4" v-bind:class="{'form-group--error': $v.pendingOrder.service_code.$error }">
                          <select v-model="pendingOrder.service_code" class="form-control" required @change="this.queryShippingIncoterm">
                            <option value="">-- {{ $t('general.input.please_select_courier_service') }} --</option>
                            <option v-for="(courierService, index) in courierServices" :value="courierService.service_code" :key="index">
                              {{ courierService.service_code }} - {{ courierService.internal_name }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="reference_no" class="col-sm-2 col-form-label">{{ $t('delivery.label.reference_no') }}</label>
                        <div class="col-sm-4" v-bind:class="{'form-group--error': $v.pendingOrder.reference_no.$error }">
                          <input v-model="pendingOrder.reference_no" type="text" class="form-control" required />
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="shipment_content" class="col-sm-2 col-form-label">{{ $t('delivery.label.shipment_content') }}</label>
                        <div class="col-sm-6" v-bind:class="{'form-group--error': $v.pendingOrder.shipment_content.$error }">
                          <input v-model="pendingOrder.shipment_content" type="text" name="shipment_content" class="form-control" required />
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="product_type" class="col-sm-2 col-form-label">{{ $t('delivery.label.product_type') }}</label>
                        <div class="col-sm-6">
                          <div class="form-check form-check-inline">
                            <input v-model="pendingOrder.product_type" class="form-check-input" checked="checked" type="radio" name="product_type" id="inlineRadio1" value="1">
                            <label class="form-check-label" for="inlineRadio1">{{ $t('general.package.package') }}</label>
                          </div>
                          <div class="form-check form-check-inline">
                            <input v-model="pendingOrder.product_type" class="form-check-input" type="radio" name="product_type" id="inlineRadio2" value="2">
                            <label class="form-check-label" for="inlineRadio2">{{ $t('general.package.plastic_bag') }}</label>
                          </div>
                          <div class="form-check form-check-inline">
                            <input v-model="pendingOrder.product_type" class="form-check-input" type="radio" name="product_type" id="inlineRadio3" value="3">
                            <label class="form-check-label" for="inlineRadio3">{{ $t('general.package.letters') }}</label>
                          </div>
                           <div class="form-check form-check-inline">
                           </div>
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="package_num" class="col-sm-2 col-form-label">{{ $t('delivery.label.package_num') }}</label>
                        <div class="col-sm-2">
                          <input v-model="pendingOrder.package_num" type="number" name="package_num" class="form-control" />
                        </div>
                        <label for="battery" class="col-sm-2 col-form-label">{{ $t('delivery.label.battery') }}</label>
                        <div class="col-sm-2" v-bind:class="{'form-group--error': $v.pendingOrder.battery.$error }">
                          <select v-model="pendingOrder.battery" class="form-control" required>
                            <option value="0">{{ $t('general.no') }}</option>
                            <option value="1">{{ $t('general.yes') }}</option>
                          </select>
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="declared_value" class="col-sm-2 col-form-label">{{ $t('delivery.label.declared_value') }}</label>
                        <div class="col-sm-2" v-bind:class="{'form-group--error': $v.pendingOrder.declared_value.$error }">
                          <input v-model="pendingOrder.declared_value" type="number" name="declared_value" class="form-control" required/>
                        </div>
                        <label for="declared_currency" class="col-sm-2 col-form-label">{{ $t('delivery.label.declared_currency') }}</label>
                        <div class="col-sm-2" v-bind:class="{'form-group--error': $v.pendingOrder.declared_currency.$error }">
                          <input v-model="pendingOrder.declared_currency" type="text" name="declared_currency" class="form-control" required/>
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="incoterm" class="col-sm-2 col-form-label">{{ $t('delivery.label.incoterm') }}</label>
                        <div class="col-sm-4" v-bind:class="{'form-group--error': $v.pendingOrder.incoterm.$error }">
                          <select v-model="pendingOrder.incoterm" class="form-control" required>
                            <option value="">-- {{ $t('general.input.please_select_a_incoterm') }} --</option>
                            <option v-for="(incoterm, index) in incoterms" :value="incoterm.incoterm" :key="index">{{incoterm.incoterm }} </option>
                          </select>
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="insurance_value" class="col-sm-2 col-form-label">{{ $t('delivery.label.insurance_value') }}</label>
                        <div class="col-sm-2" v-bind:class="{'form-group--error': $v.pendingOrder.insurance_value.$error }">
                          <input v-model="pendingOrder.insurance_value" type="number" name="insurance_value" class="form-control" required />
                        </div>
                      </div>
                      <div class="form-group row" v-if="showWeidhtField">
                        <label for="weight" class="col-sm-2 col-form-label">{{ $t('delivery.label.weight') }}</label>
                        <div class="col-sm-1" v-bind:class="{'form-group--error': $v.pendingOrder.weight.$error }">
                          <input v-model="pendingOrder.weight" type="number" name="weight" class="form-control" required/>
                        </div>
                        <label for="weight_unit" class="col-sm-1 col-form-label">{{ $t('delivery.label.weight_unit') }}</label>
                        <div class="col-sm-1">
                          <input v-model="pendingOrder.weight_unit" readonly="" type="text" name="weight_unit" class="form-control" />
                        </div>
                        <label for="height" class="col-sm-1 col-form-label">{{ $t('delivery.label.height') }}</label>
                        <div class="col-sm-1">
                          <input v-model="pendingOrder.height" type="number" name="height" class="form-control" />
                        </div>
                      </div>
                      <div class="form-group row" v-if="showWeidhtField">
                        <label for="width" class="col-sm-2 col-form-label">{{ $t('delivery.label.width') }}</label>
                        <div class="col-sm-1">
                          <input v-model="pendingOrder.width" type="number" name="width" class="form-control" />
                        </div>
                        <label for="length" class="col-sm-1 col-form-label">{{ $t('delivery.label.length') }}</label>
                        <div class="col-sm-1">
                          <input v-model="pendingOrder.length" type="number" name="length" class="form-control" />
                        </div>
                        <label for="dimension_uom" class="col-sm-1 col-form-label" style="padding-left:0px;padding-right:0px;">{{ $t('delivery.label.dimension_uom') }}</label>
                        <div class="col-sm-1">
                          <input v-model="pendingOrder.dimension_uom" readonly="" type="text" name="dimension_uom" class="form-control" />
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="remark" class="col-sm-2 col-form-label">{{ $t('delivery.label.remark') }}</label>
                        <div class="col-sm-6">
                          <input v-model="pendingOrder.remark" type="text" name="remark" class="form-control" />
                        </div>
                      </div>
                  </div><!--col-->
              </div><!--row-->

              <div class="row mt-4">
                <div class="col-sm-5">
                  <h5 class="card-title mb-0">
                    {{ $t('delivery.label.sender_info') }}
                  </h5>
                </div>
              </div>
              <hr />
              <div class="row">
                  <div class="col">
                      <div class="form-group row">
                        <label for="company" class="col-sm-2 col-form-label">{{ $t('delivery.label.company') }}</label>
                        <div class="col-sm-4">
                          <input v-model="pendingOrder.company" type="text" name="company" class="form-control" required/>
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="address" class="col-sm-2 col-form-label">{{ $t('delivery.label.address') }}</label>
                        <div class="col-sm-6" v-bind:class="{'form-group--error': $v.pendingOrder.address.$error }">
                          <input v-model="pendingOrder.address" type="text" name="address" class="form-control" required />
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="address1" class="col-sm-2 col-form-label">{{ $t('delivery.label.address1') }}</label>
                        <div class="col-sm-6">
                          <input v-model="pendingOrder.address1" type="text" name="address" class="form-control" required />
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="address2" class="col-sm-2 col-form-label">{{ $t('delivery.label.address2') }}</label>
                        <div class="col-sm-6">
                          <input v-model="pendingOrder.address2" type="text" name="address" class="form-control" required />
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="email" class="col-sm-2 col-form-label">{{ $t('delivery.label.email') }}</label>
                        <div class="col-sm-3" v-bind:class="{'form-group--error': $v.pendingOrder.email.$error }">
                          <input v-model="pendingOrder.email" type="email" class="form-control" />
                        </div>
                        <label for="delivery_name" class="col-sm-2 col-form-label">{{ $t('delivery.label.delivery_name') }}</label>
                        <div class="col-sm-3" v-bind:class="{'form-group--error': $v.pendingOrder.delivery_name.$error }">
                          <input v-model="pendingOrder.delivery_name" type="text" class="form-control" />
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="country" class="col-sm-2 col-form-label">{{ $t('delivery.label.country_code') }}</label>
                        <div class="col-sm-3" v-bind:class="{'form-group--error': $v.pendingOrder.country.$error }">
                          <input v-model="pendingOrder.country" type="text" name="country" class="form-control" required/>
                        </div>
                        <label for="district" class="col-sm-2 col-form-label">{{ $t('delivery.label.district') }}</label>
                        <div class="col-sm-3" >
                          <input v-model="pendingOrder.district" type="text" name="district" class="form-control" />
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="city" class="col-sm-2 col-form-label">{{ $t('delivery.label.city') }}</label>
                        <div class="col-sm-3" v-bind:class="{'form-group--error': $v.pendingOrder.city.$error }">
                          <input v-model="pendingOrder.city" type="text" name="city" class="form-control" required/>
                        </div>
                        <label for="state" class="col-sm-2 col-form-label">{{ $t('delivery.label.state') }}</label>
                        <div class="col-sm-3">
                          <input v-model="pendingOrder.state" type="text" name="state" class="form-control" />
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="postal" class="col-sm-2 col-form-label">{{ $t('delivery.label.postal_code') }}</label>
                        <div class="col-sm-3" v-bind:class="{'form-group--error': $v.pendingOrder.postal.$error }">
                          <input v-model="pendingOrder.postal" type="text" name="postal" class="form-control" required/>
                        </div>
                        <label for="phone" class="col-sm-2 col-form-label">{{ $t('delivery.label.phone') }}</label>
                        <div class="col-sm-3">
                          <input v-model="pendingOrder.phone" type="text" name="phone" class="form-control" />
                        </div>
                      </div>
                  </div><!--col-->
              </div><!--row-->
              <div class="">
                <div class="row mt-4">
                  <div class="col-sm-5">
                    <h5 class="card-title mb-0">
                        {{ $t('delivery.label.item_details') }}
                    </h5>
                  </div><!--col-->
                </div>
                <hr />
                <div class="quotation-item-form">
                  <div class="form-group row">
                    <label class="col-md-2 col-form-label" for="sku">{{ $t('delivery.label_detail.sku') }}</label>
                    <div class="col-md-4" v-bind:class="{'form-group--error': $v.inputItem.sku.$error }">
                      <input type="text"  v-model.trim="inputItem.sku" class="form-control" placeholder="">
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-2 col-form-label" for="product_name">{{ $t('delivery.label_detail.product_name') }}</label>
                    <div class="col-md-6" v-bind:class="{'form-group--error': $v.inputItem.product_name.$error }">
                      <input type="text"  v-model.trim="inputItem.product_name" class="form-control" placeholder="">
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-2 col-form-label" for="description_export">{{ $t('delivery.label_detail.description_export') }}</label>
                    <div class="col-md-6" v-bind:class="{'form-group--error': $v.inputItem.description_export.$error }">
                      <input type="text"  v-model.trim="inputItem.description_export" class="form-control" placeholder="">
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-2 col-form-label" for="description_import">{{ $t('delivery.label_detail.description_import') }}</label>
                    <div class="col-md-6" v-bind:class="{'form-group--error': $v.inputItem.description_import.$error }">
                      <input type="text"  v-model.trim="inputItem.description_import" class="form-control" placeholder="">
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-2 col-form-label" for="country_of_origin">{{ $t('delivery.label_detail.country_of_origin') }}</label>
                    <div class="col-md-2" v-bind:class="{'form-group--error': $v.inputItem.country_of_origin.$error }">
                      <input type="text"  v-model.trim="inputItem.country_of_origin" class="form-control">
                    </div>
                    <label class="col-md-2 col-form-label" for="quantity">{{ $t('delivery.label_detail.quantity') }}</label>
                    <div class="col-md-2" v-bind:class="{'form-group--error': $v.inputItem.quantity.$error }">
                      <input type="number"  v-model.trim="inputItem.quantity" class="form-control" placeholder="">
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-2 col-form-label" for="weight">{{ $t('delivery.label.weight') }}</label>
                    <div class="col-md-2" v-bind:class="{'form-group--error': $v.inputItem.weight.$error }">
                      <input type="number"  v-model.trim="inputItem.weight" class="form-control">
                    </div>
                    <label class="col-md-2 col-form-label" for="weight_unit">{{ $t('delivery.label.weight_unit') }}</label>
                    <div class="col-md-2">
                      <input type="text"  v-model.trim="inputItem.weight_unit"  class="form-control" readonly="">
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-2 col-form-label" for="item_declared_value">{{ $t('delivery.label.declared_value') }}</label>
                    <div class="col-md-2" v-bind:class="{'form-group--error': $v.inputItem.item_declared_value.$error }">
                      <input type="number"  v-model.trim="inputItem.item_declared_value" class="form-control">
                    </div>
                    <label class="col-md-2 col-form-label" for="hscode">{{ $t('delivery.label_detail.hscode') }}</label>
                    <div class="col-md-2">
                      <input type="text"  v-model.trim="inputItem.hscode" class="form-control">
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-2 col-form-label" for="hsdescription">{{ $t('delivery.label_detail.hsdescription') }}</label>
                    <div class="col-md-6">
                      <input type="text"  v-model.trim="inputItem.hsdescription" name="hsdescription" class="form-control" placeholder="">
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-md-2">
                      <button type="button" class="btn btn-sm btn-success" @click="handleAddItem"><i class="fa fa-dot-circle-o"></i> {{ $t('general.button.add') }}</button>
                    </div>
                  </div>
                </div>
                <div class="table-responsive">
                  <table class="table">
                    <thead>
                      <tr>
                        <th>{{ $t('delivery.label_detail.line_no') }}</th>
                        <th>{{ $t('delivery.label_detail.sku') }}</th>
                        <th>{{ $t('delivery.label_detail.product_name') }}</th>
                        <th>{{ $t('delivery.label_detail.description_export') }}</th>
                        <th>{{ $t('delivery.label_detail.description_import') }}</th>
                        <th>{{ $t('delivery.label_detail.country_of_origin') }}</th>
                        <th>{{ $t('delivery.label_detail.quantity') }}</th>
                        <th>{{ $t('delivery.label.weight') }}</th>
                        <th>{{ $t('delivery.label_detail.item_declared_value') }}</th>
                        <th>{{ $t('delivery.label_detail.hscode') }}</th>
                        <th>{{ $t('delivery.label_detail.hsdescription') }}</th>
                        <th>{{ $t('general.action') }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in pendingOrder.item" :key="index">
                        <td>{{ index+1 }}</td>
                        <td>{{ item.sku}}</td>
                        <td>{{ item.product_name}}</td>
                        <td>{{ item.description_export}}</td>
                        <td>{{ item.description_import}}</td>
                        <td>{{ item.country_of_origin}}</td>
                        <td>{{ item.quantity}}</td>
                        <td>{{ item.weight}}</td>
                        <td>{{ item.item_declared_value}}</td>
                        <td>{{ item.hscode}}</td>
                        <td>{{ item.hsdescription}}</td>
                        <td><button type="button" class="btn btn-sm btn-danger" @click="handleDeleteItem(index)"><i class="fa fa-dot-circle-o"></i> {{ $t('general.button.delete') }}</button></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div slot="footer">
                <div class="row">
                    <div class="col-7">
                        <div class="float-left"></div>
                    </div><!--col-->
                    <div class="col-5">
                        <div class="float-right">
                            <b-button type="submit" size="sm" variant="primary" @click.stop.prevent="handleSubmit"><i class="fa fa-dot-circle-o"></i> {{ $t('general.button.submit') }}</b-button>
                        </div>
                    </div><!--col-->
                </div><!--row-->
              </div>
          </div><!--card-body-->
      </div><!--card-->
    </form>
   <loading-panel v-if="showLoadingPanel"></loading-panel>
  </div>
</template>
<script>
import { required, minLength, maxLength, email } from 'vuelidate/lib/validators'
import loadingPanel from '@/components/LoadingPanel'

export default {
  name: 'PendingEdit',
  components: {
    loadingPanel
  },
  beforeCreate () {
    this.axios.get('delivery/pending/create').then(response => {
      if (response.data && response.data.courierServices) {
        this.courierServices = response.data.courierServices
      } else {
        this.$swal({
          title: 'You have no services',
          text: 'Please contact LME IT to create services First!',
          icon: 'warning'
        })
      }
      // this.pendingOrder.service_code = this.couriers[0].id
    }).catch(error => {
      console.log(error)
    })
  },
  data () {
    return {
      courierServices: [],
      incoterms: [],
      pendingOrder: {
        id: '',
        service_code: '',
        reference_no: '',
        company: '',
        email: '',
        shipment_content: '',
        delivery_name: '',
        address: '',
        address1: '',
        address2: '',
        country: '',
        district: '',
        city: '',
        state: '',
        postal: '',
        phone: '',
        battery: '0',
        product_type: '1',
        package_num: '',
        courier_reference_id: '',
        declared_value: '',
        declared_currency: '',
        insurance_value: '',
        shipping_code: '',
        incoterm: '',
        weight: '',
        weight_unit: 'G',
        height: 0,
        width: 0,
        dimension_uom: 'CM',
        length: 0,
        remark: '',
        item: []
      },
      inputItem: {
        sku: '',
        product_name: '',
        description_export: '',
        description_import: '',
        country_of_origin: '',
        quantity: '',
        weight: '',
        weight_unit: 'G',
        item_declared_value: '',
        hscode: '',
        hsdescription: ''
      },
      showLoadingPanel: false,
      showDismissibleAlert: false,
      alertVariant: '',
      alertMessage: '',
      message: ''
    }
  },
  validations: {
    pendingOrder: {
      service_code: {
        required
      },
      reference_no: {
        required
      },
      shipment_content: {
        required
      },
      incoterm: {
        required
      },
      email: {
        email
      },
      delivery_name: {
        required
      },
      address: {
        required
      },
      country: {
        required,
        maxLength: maxLength(2)
      },
      city: {
        required
      },
      postal: {
        required
      },
      battery: {
        required
      },
      declared_value: {
        required
      },
      declared_currency: {
        required
      },
      insurance_value: {
        required
      },
      weight: {
        required
      },
      item: []
    },
    inputItem: {
      sku: {
        required
      },
      product_name: {
        required,
        minLength: minLength(1)
      },
      description_export: {
        required,
        minLength: minLength(1)
      },
      description_import: {
        required
      },
      country_of_origin: {
        required
      },
      quantity: {
        required
      },
      weight: {
        required
      },
      item_declared_value: {
        required
      }
    }
  },
  computed: {
    // 计算属性的 getter
    showWeidhtField: function () {
      // `this` 指向 vm 实例
      return this.pendingOrder.product_type === '1'
    }
  },
  methods: {
    handleSubmit () {
      this.$v.pendingOrder.$touch()
      if (!this.$v.pendingOrder.$error) {
        // create pendingOrder
        this.showLoadingPanel = true
        this.axios.post('/delivery/pending', this.pendingOrder).then(response => {
          this.showLoadingPanel = false
          this.showAlert('success', this.$t('delivery.label.create_pending_success'))
          this.$swal({
            title: response.data?.message,
            icon: 'success',
            showCancelButton: false,
            confirmButtonText: this.$t('general.button.ok')
          }).then(() => {
            location.reload()
          })
        }).catch(error => {
          this.showLoadingPanel = false
          if (error.data && error.data.message) {
            this.showAlert('danger', error.data.message)
          }
        })
      }
    },
    queryShippingIncoterm () {
      this.pendingOrder.incoterm = ''
      if (this.pendingOrder.service_code && this.pendingOrder.service_code !== '') {
        this.axios.get('courier-services/' + this.pendingOrder.service_code + '/options').then(response => {
          if (response && response.data !== null) {
            this.incoterms = response.data.incoterms
          }
        }).catch(error => {
          this.showAlert('danger', error.data.message)
        })
      } else {
        this.incoterms = []
      }
    },
    handleAddItem () {
      this.$v.inputItem.$touch()
      if (this.$v.inputItem.$error) {
        this.$swal({
          title: this.$t('delivery.warning.please_input_all_the_required_information'),
          icon: 'warning',
          confirmButtonText: this.$t('general.button.ok'),
          animation: false,
          customClass: 'animated tada'
        })
      } else {
        let result = this.checkExistSku()
        if (!result) {
          let copyObj = Object.assign({}, this.inputItem)
          this.pendingOrder.item.push(copyObj)
        }
      }
    },
    checkExistSku () {
      var result = false
      var vm = this
      this.pendingOrder.item.forEach(function (item) {
        if (item.sku === vm.inputItem.sku) {
          result = true
          vm.$swal({
            title: 'The SKU has added, please check your data',
            icon: 'warning',
            animation: false,
            customClass: 'animated tada'
          })
        }
      })
      return result
    },
    handleDeleteItem (index) {
      this.pendingOrder.item.splice(index, 1)
    },
    showAlert (alertVariant, message) {
      this.showDismissibleAlert = true
      this.alertVariant = alertVariant
      this.alertMessage = message
    }
  }
}
</script>
